export function clampNum(num: number, min: number, max: number): number {
  return Math.min(Math.max(num, min), max)
}

export function getRandomNumber(min: number, max: number): number {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Convert a string or number (percentage) into it's decimal value
 * with a specified number of decimal places
 */
export const percentToDecimal = (
  num: string | number,
  decimal: number
): string => {
  const parsedNum: number =
    typeof num === 'string' ? Number.parseFloat(num) : num

  return (parsedNum / 100).toFixed(decimal || 2)
}
